

import React from 'react';
import styles from './header.module.scss';
import MenuBar from './menuBar/menuBar';
import Muhurtham from '../../common/muhurtham/muhurtham';

export default function Header(): JSX.Element {


  return (
    <div  className='no_print'>
      <div className={styles.paperContainer}>
        <img className={styles.headerBanner} src="/images/Homepage_Shiva_vishnu_banner.svg" />
      </div>
      <div className={styles.menuAndMuhurtham}>
        <MenuBar />
        <Muhurtham />
      </div>
    </div>
  );
}